// 20250628: xt this is iterated over by AgencyList to build the selectable item list upon login.
//           this really should be names: AgencyListItem
// COMPLETELY REWROTE AGENCY TO STORE THE SELECTEDAGENCY CORRECLY IN STATE AND LS

// import React from 'react';
// import PropTypes from 'prop-types';
// import LinkContainer from '../LinkContainer/LinkContainer'; // Custom LinkContainer for react-router-dom v6

// const Agency = ({ agency, languageCode, pathRef }) => (
//   <LinkContainer to={`${pathRef}/${agency._id}`} style={{ cursor: 'pointer' }}>
//     <li className="list-group-item list-group-item-action">
//       {agency.name[languageCode]}
//     </li>
//   </LinkContainer>
// );

// Agency.propTypes = {
//   agency: PropTypes.object.isRequired,
//   languageCode: PropTypes.string.isRequired,
//   pathRef: PropTypes.string.isRequired,
// };

// export default Agency; // 'export default' is react and this means that Agency is the main component in this file

// this is complete replament from chat to save agency id properly
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { selectAgencyId } from '../../actions/agencyStubs'; // Existing action

const Agency = ({ agency, languageCode, pathRef }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    const agencyId = agency._id;

    // ✅ Save to Redux
    dispatch(selectAgencyId(agencyId));

    // ✅ Save to localStorage
    localStorage.setItem('selected_agency', agencyId);

    // ✅ Navigate to the correct tab (e.g., /dashboard/agency123)
    navigate(`${pathRef}/${agencyId}`);
  };

  return (
    <li
      className="list-group-item list-group-item-action"
      style={{ cursor: 'pointer' }}
      onClick={handleClick}
    >
      {agency.name[languageCode]}
    </li>
  );
};

Agency.propTypes = {
  agency: PropTypes.object.isRequired,
  languageCode: PropTypes.string.isRequired,
  pathRef: PropTypes.string.isRequired,
};

export default Agency;
